<ion-list>
  <ion-item *ngFor="let menu of menuItems" (click)="goto(menu.url)">
    <ion-icon *ngIf="menu.icon !== ''" name="{{menu.icon}}" size="small" color="{{menu.color}}"></ion-icon>
    <ion-label class="ion-margin-start">{{menu.name}}</ion-label>
  </ion-item>

</ion-list>
